<template>
  <Transition name="support-chat">
    <div
      v-if="isOpen"
      class="fixed bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.15)] flex flex-col z-[var(--support-chat-z-index,1000)] overflow-hidden transition-[width,height,top,right,bottom,left] duration-200 ease-out"
      :class="[framePosClasses, frameSizeClasses]"
    >
      <div class="flex justify-between items-center h-[33px] bg-[#3d3c3c] text-white pl-5 pr-1">
        <div class="flex items-center">
          <span class="font-semibold text-sm">Чат поддержки</span>
        </div>

        <div class="flex items-center">
          <ChatmessageDesignSwitch
            class="!h-6 mr-1"
            compact
          />

          <div class="hidden lg:flex items-center">
            <Button
              text
              rounded
              severity="secondary"
              aria-label="Развернуть почти на весь экран"
              :pt="{
                root: 'focus:!outline-none focus:!shadow-none focus:!border-transparent active:!shadow-none active:!border-transparent p-2'
              }"
              @click="expandFull"
            >
              <i
                class="text-white text-[14px]"
                :class="isFull ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"
              ></i>
            </Button>

            <Button
              text
              rounded
              severity="secondary"
              aria-label="Переключить размер окна"
              :pt="{
                root: 'focus:!outline-none focus:!shadow-none focus:!border-transparent active:!shadow-none active:!border-transparent p-2'
              }"
              @click="toggleExpand"
            >
              <i
                class="text-white text-[14px]"
                :class="expandIcon"
              ></i>
            </Button>
          </div>

          <Button
            text
            rounded
            severity="secondary"
            aria-label="Закрыть чат"
            :pt="{
              root: 'focus:!outline-none focus:!shadow-none focus:!border-transparent active:!shadow-none active:!border-transparent p-2'
            }"
            @click="toggleChat"
          >
            <img
              src="@/assets/support-chat/CloseChat.svg"
              class="w-5 h-5"
              alt="chat"
            />
          </Button>
        </div>
      </div>

      <div class="flex flex-1 min-h-0 bg-[#f8f9fa] p-0">
        <ChatMessageThread
          :thread-id="threadId ?? undefined"
          class="h-full w-full !p-0"
          supportChat
        />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { ChatMessageThread } from '@/widgets/ChatMessageThread';
import { ChatmessageDesignSwitch } from '@/features/chatmessage';
import Button from 'primevue/button';
import { useSupportChat } from '../model';

const props = defineProps<{
  isOpen: boolean;
  toggleChat: () => void;
  threadId?: string | number | null;
}>();

const { isExpanded, isFull, framePosClasses, frameSizeClasses, expandIcon, toggleExpand, expandFull } =
  useSupportChat();

watch(
  () => props.isOpen,
  open => {
    if (!open) {
      isFull.value = false;
      isExpanded.value = false;
    }
  }
);
</script>
